import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Main from './views/main'
import Stage1 from './views/1. 이전에 사용해본적 있다없다'
import Stage2 from './views/2. 나이입력'
import Stage3 from './views/3. 동의'
import Stage4 from './views/4. 결혼 직업 성별'
import Stage5 from './views/5. PSS 스키마'
import Stage6 from './views/6. HMPS BAI K_SSES UCLA'
import Stage7 from './views/7. 전화번호 재확인'
import Result from './views/examResult'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  {
    path: '/stage1',
    name: 'stage1',
    component: Stage1,
  },
  {
    path: '/stage2',
    name: 'stage2',
    component: Stage2,
  },
  {
    path: '/stage3',
    name: 'stage3',
    component: Stage3,
  },
  {
    path: '/stage4',
    name: 'stage4',
    component: Stage4,
  },
  {
    path: '/stage5',
    name: 'stage5',
    component: Stage5,
  },
  {
    path: '/stage6',
    name: 'stage6',
    component: Stage6,
  },
  {
    path: '/stage7',
    name: 'stage7',
    component: Stage7,
  },
  {
    path: '/result',
    name: 'result',
    component: Result,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => {
    return {
      top: 0,
    }
  },
})

export default router
